import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';

export default function Error404() {
    const scrollRef = useRef(null);
    const { t } = useTranslation();
    const translate = t;
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content error-page" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap">
             <div className="error-404">
                <div className="icon-404"></div>
                <span>Page not found</span>
             </div>
          </div>
        </section>
      </div>
     </div>
  )
}
